import api from './api';

export const getLensesCatalog        = ()       => api.get('/api/lenses');
export const getEnvironmentalLens    = (params) => api.get('/api/lenses/environmental',         { params });
export const getTraditionalKnowledge = (params) => api.get('/api/lenses/traditional-knowledge', { params });
export const getSpatialLens          = (params) => api.get('/api/lenses/spatial',               { params });
export const getSeasonalLens         = (params) => api.get('/api/lenses/seasonal',              { params });
export const getCommunityHealthLens  = ()       => api.get('/api/lenses/community-health');
